import { RadioGroup, RadioItem } from './RadioGroup'

const collection: RadioItem[] = [{ label: 'Gráfico' }, { label: 'Calendario' }]
const DealVistaSelector: React.FC<{ vistaSelected: number; vistaClicked: (idx: number) => void }> = ({
  vistaSelected,
  vistaClicked,
}) => {
  return (
    <RadioGroup
      collection={collection}
      name={'vista'}
      checked={vistaSelected}
      callback={vistaClicked}
      label="Vista"
      direction="horizontal"
    />
  )
}
export default DealVistaSelector
